import { render, staticRenderFns } from "./IncaMetrics.vue?vue&type=template&id=e71ea84a&scoped=true"
import script from "./IncaMetrics.vue?vue&type=script&lang=js"
export * from "./IncaMetrics.vue?vue&type=script&lang=js"
import style0 from "./IncaMetrics.vue?vue&type=style&index=0&id=e71ea84a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71ea84a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e71ea84a')) {
      api.createRecord('e71ea84a', component.options)
    } else {
      api.reload('e71ea84a', component.options)
    }
    module.hot.accept("./IncaMetrics.vue?vue&type=template&id=e71ea84a&scoped=true", function () {
      api.rerender('e71ea84a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/home_page/IncaMetrics.vue"
export default component.exports